<template>
  <div class="t-lk-modal__content t-lk-accept-modal">
    <h2 class="t-lk-modal__title">Основные правила участия в системе ЛИДер</h2>
    <ul class="t-lk-accept-modal__text">
      <li class="t-lk-accept-modal__line">Внесение информации о сроках возможной сделки в течение 7 дней</li>
      <li class="t-lk-accept-modal__line">
        На стадии подписания договора с заказчиком необходимо установить статус «Выиграл». При отсутствии перспектив сделки необходимо
        установить статус «Сделка не состоялась». При переносе сроков сделки необходимо указать новые сроки
      </li>
      <li class="t-lk-accept-modal__line">Качественно и в срок отрабатывать лиды, независимо от суммы сделки</li>
      <li class="t-lk-accept-modal__line">Осуществлять закупку ПО и оборудования для реализации сделки с заказчиком в Axoft</li>
      <li class="t-lk-accept-modal__line">
        В случае, если заказчику вы осуществляете допродажу ПО или Оборудования из портфеля Axoft, мы ожидаем от вас закупку его в
        Axoft
      </li>
    </ul>

    <a class="t-lk-modal__link" target="_blank" :href="faqLink">
      Подробная информация
    </a>

    <div class="t-lk-refuse-lead t-lk-modal__form"></div>

    <div class="t-lk-change-date__row">
      <div class="t-btn _green _lk" @click="acceptLead">Согласиться и принять лид</div>

      <div class="t-lk-change-date__close" @click="modalClose">
        {{ $root.staticText.lk.lkModalBtn }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'accept-lead-modal',
  props: ['props'],
  computed: {
    ...mapGetters({
      modalPorops: 'modal/getModalProps',
    }),
    faqLink() {
      const isProd = process.env.NODE_ENV === 'production'
      return isProd ? '/lk/faq/lidogeneratsiya' : '/lk/faq'
    },
  },
  methods: {
    ...mapActions({
      modalClose: 'modal/modalClose',
      lk_acceptLead: 'lk/leads/acceptLead',
    }),
    async acceptLead() {
      await this.lk_acceptLead(this.props.leadId)

      await this.props.acceptLeadHandler?.()
    },
  },
}
</script>

<style lang="sass">
.t-lk-accept-modal
  max-width: 450px

  &__text
    margin: 16px 0 24px
    padding-left: 18px
    line-height: 150%
    color: #4d556d

  &__line
    list-style: disc

  @media screen and (max-width: 920px)
      max-width: 100%

.t-lk-modal__link
  text-align: center
  margin-top: 24px
  width: 100%
  display: block
  text-decoration: underline
  color: #00b0bd
</style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/accept-lead-modal.vue